import React from 'react';
import clsx from 'clsx';
import CardHeaderContent from './CardHeaderContent';
import SelectableCard from './SelectableCard';

const CardHeader = ({
  children,
  className,
  disabled,
  entity,
  href,
  icon,
  iconColour,
  link,
  loading,
  message,
  text,
  onSelect,
  onClick,
  selected,
  single,
  title,
}) => (
  <SelectableCard
    single={single}
    selected={selected}
    onClick={onSelect}
    disabled={disabled}
    className={clsx('aridhia-card-header', className)}
  >
    <CardHeaderContent
      entity={entity}
      href={href}
      icon={icon}
      iconColour={iconColour}
      link={link}
      loading={loading}
      message={message}
      onClick={onClick}
      text={text}
      title={title}
    >
      {children}
    </CardHeaderContent>
  </SelectableCard>
);

export default CardHeader;
